import {NavigationComponent} from "../components/public/navigation.component";
import {useEffect, useState} from "react";
import axios from "axios";
import {useParams} from "react-router-dom";
import ReactMarkdown from "react-markdown";

export const Article1Page = () => {

    const { id } = useParams(); // Pobiera ID artykułu z URL
    const [article, setArticle] = useState(null);


  return (
      <>
        <div className={"tesapp-tesapp"}>
            <div className={"tesapp-component"}>
                <div className={"tesapp-component"}>
                    <div className={"tesapp-navigation"}>
                        <div className={"tesapp-navigation-branding"}><a href={"/"}>
                            <img src={"/logo-temnography.png"} alt={"Logo Temnography®"} width={100}
                                 className={"tesapp-branding-logo"}/></a>
                        </div>
                        <div className={"tesapp-navigation-elementor"}>
                            <ul className={"tesapp-el-builder"}>
                                <li><a href={"/news"}><b>Aktualności</b></a></li>
                                <li><a href={"#jak-to-dziala"}>Jak to działa?</a></li>
                                <li><a href={"#zalety"}>Zalety z korzystania</a></li>
                                <li><a href={"#wersje-produktu"}>Wersje produktu</a></li>
                                <li><a href={"#dystrybutor"}>Dystrybucja</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className={"tesapp-present"}>
                        <div className={"tesapp-present-content"}>
                            <h1 className={"tesapp-f-title"}>TES HT100 technologia Temnografii potwierdzona badaniami klinicznymi</h1>
                        </div>
                    </div>
                </div>
                <div className={"tesapp-banner"}>
                    <div className={"tesapp-line-space"}/>
                </div>
                <div className={"tesapp-container"}
                     style={{marginTop: "-50px", display: "block", paddingTop: 0}}>
                    <div className={"tesapp-container-content"}>
                        <div className={"tesapp-article-informations"}>
                            <div>
                                Autor artykułu: <b>Paweł Nowicki</b>
                            </div>
                            <div>
                                Opublikowano: 25.09.2026
                            </div>
                        </div>
                        <div className={"tesapp-c-component"}>
                            <article className="tes-ht100-article">
      <header>
        <h1>TES HT100 technologia Temnografii potwierdzona badaniami klinicznymi</h1>
        <p className="author-info">
          <strong>Paweł Nowicki</strong>
          <br />
          Koordynator badań klinicznych TES HT100 Polska
        </p>
      </header>

      <section>
        <h2>Od badań naukowych do praktyki klinicznej</h2>
        <p>
          Wczesna ocena pacjentów z urazami głowy oraz ostrymi objawami neurologicznymi pozostaje jednym z największych wyzwań współczesnej medycyny ratunkowej. Każdego dnia oddziały ratunkowe przyjmują pacjentów z zaburzeniami mowy, równowagi, świadomości, omdleniami czy urazami głowy, u których konieczne jest szybkie wykluczenie nieprawidłowości wewnątrzczaszkowych.
        </p>
        <p>
          TES HT100 wykorzystuje technologię Temnografii (Tissue Electromagnetic Scanning), umożliwiającą nieinwazyjną analizę właściwości elektromagnetycznych tkanek mózgowych. Badanie wykonywane jest bez promieniowania jonizującego, przy użyciu fal elektromagnetycznych o niskiej mocy, a wynik uzyskiwany jest w ciągu kilku minut.
        </p>
        <p>
          Najważniejsze jest jednak to, że skuteczność urządzenia została poddana ocenie klinicznej w rzeczywistych warunkach szpitalnych.
        </p>
      </section>

      <section>
        <h2>Badanie kliniczne TESCO w Szpitalu Pineta Grande</h2>
        <p>
          Największe dotychczas badanie dotyczące TES HT100 zostało przeprowadzone na Oddziale Ratunkowym Szpitala Pineta Grande w Castel Volturno we Włoszech. Wstępne wyniki pierwszej analizy okresowej przedstawiono w artykule przyjętym do publikacji w czasopiśmie <em>BMC Emergency Medicine</em>.
        </p>
        
        <p>Badanie TESCO zostało zaprojektowane jako:</p>
        <ul>
          <li>prospektywne,</li>
          <li>zaślepione,</li>
          <li>jednoośrodkowe badanie dokładności diagnostycznej,</li>
          <li>prowadzone w warunkach codziennej pracy oddziału ratunkowego.</li>
        </ul>

        <p>Do analizy pośredniej włączono 301 dorosłych pacjentów, u których wykonano zarówno badanie TES HT100, jak i tomografię komputerową głowy.</p>

        <p>Badana populacja obejmowała:</p>
        <ul>
          <li>151 pacjentów z łagodnym urazem głowy,</li>
          <li>150 pacjentów z ostrymi objawami neurologicznymi o podłożu nieurazowym.</li>
        </ul>

        <p>
          Średni wiek uczestników wynosił około 63 lata, a ponad połowa pacjentów miała więcej niż 65 lat. Była to więc populacja dobrze odzwierciedlająca rzeczywiste warunki pracy oddziału ratunkowego.
        </p>

        <p>Pacjenci zgłaszali się między innymi z:</p>
        <ul>
          <li>omdleniami,</li>
          <li>zaburzeniami równowagi,</li>
          <li>zaburzeniami mowy,</li>
          <li>dezorientacją,</li>
          <li>zaburzeniami pamięci,</li>
          <li>podejrzeniem udaru mózgu,</li>
          <li>łagodnymi urazami głowy wymagającymi wykonania tomografii komputerowej.</li>
        </ul>
      </section>

      <section>
        <h2>Wyniki badania</h2>
        <p>
          W analizowanej grupie TES HT100 wykazał bardzo wysoką skuteczność w identyfikacji pacjentów z nieprawidłowościami wewnątrzczaszkowymi potwierdzonymi w badaniu CT.
        </p>

        <h3>Wyniki dla całej populacji (n = 301)</h3>
        <table>
          <thead>
            <tr>
              <th>Parametr</th>
              <th>Wynik</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Czułość</td>
              <td>96,2%</td>
            </tr>
            <tr>
              <td>Swoistość</td>
              <td>82,6%</td>
            </tr>
            <tr>
              <td>Dodatnia wartość predykcyjna (PPV)</td>
              <td>85,8%</td>
            </tr>
            <tr>
              <td>Ujemna wartość predykcyjna (NPV)</td>
              <td>95,2%</td>
            </tr>
            <tr>
              <td>Dokładność diagnostyczna</td>
              <td>89,7%</td>
            </tr>
          </tbody>
        </table>

        <p>
          Wyniki wskazują na wysoką czułość oraz wysoką ujemną wartość predykcyjną (NPV) TES HT100 w porównaniu z tomografią komputerową, która stanowiła standard odniesienia w badaniu. Parametry te są szczególnie istotne w kontekście potencjalnego zastosowania urządzenia jako narzędzia wspierającego wczesną ocenę i triage pacjentów.
        </p>

        <h3>Pacjenci z objawami neurologicznymi</h3>
        <p>W grupie 150 pacjentów z objawami neurologicznymi urządzenie osiągnęło:</p>
        <ul>
          <li>czułość 96,5%,</li>
          <li>swoistość 87,3%,</li>
          <li>dokładność 92,7%.</li>
        </ul>

        <h3>Pacjenci po urazach głowy</h3>
        <p>W grupie 151 pacjentów z łagodnym urazem głowy uzyskano:</p>
        <ul>
          <li>czułość 95,7%,</li>
          <li>swoistość 79,0%,</li>
          <li>dokładność 86,7%.</li>
        </ul>

        <p>Badacze podkreślili, że wysoka czułość utrzymywała się niezależnie od wieku i płci pacjentów.</p>
      </section>

      <section>
        <h2>Program badawczy TESCO wchodzi w kolejną fazę rozwoju</h2>
        <p>
          Wyniki uzyskane w Szpitalu Pineta Grande stanowią ważny etap rozwoju technologii TES HT100, jednak nie kończą procesu jej oceny klinicznej. Po 301 pacjentach uwzględnionych w pierwszej analizie pośredniej we Włoszech włączono kolejnych 299 pacjentów, co daje łącznie 600 pacjentów zrekrutowanych w ramach włoskiej części programu TESCO. Program został następnie rozszerzony do formuły wieloośrodkowej, obejmującej również ośrodki w Polsce.
        </p>
        
        <p>
          Kolejnym etapem programu jest realizacja badania w Polsce, które obejmie 250 pacjentów kwalifikowanych do diagnostyki neurologicznej zgodnie z założeniami programu TESCO.
        </p>

        <p>Celem tego etapu jest:</p>
        <ul>
          <li>dalsze potwierdzenie skuteczności TES HT100,</li>
          <li>ocena przydatności technologii w kolejnych ośrodkach klinicznych,</li>
          <li>rozszerzenie bazy dowodów naukowych dla Temnografii,</li>
          <li>potwierdzenie wyników uzyskanych wcześniej we Włoszech.</li>
        </ul>

        <p>
          Rozszerzenie programu na Polskę pokazuje, że rozwój TES HT100 opiera się na systematycznie prowadzonych badaniach klinicznych, a producent konsekwentnie realizuje kolejne etapy walidacji tej technologii.
        </p>

        <p>
          Łącznie program TESCO zakłada objęcie 850 pacjentów: 600 pacjentów zrekrutowanych we Włoszech (301 uwzględnionych w pierwszej analizie pośredniej oraz kolejnych 299 już włączonych do badania) oraz 250 pacjentów planowanych do rekrutacji w Polsce.
        </p>
      </section>

      <section>
        <h2>Dlaczego badanie w Szpitalu Pineta Grande jest tak ważne?</h2>
        <p>
          Badanie przeprowadzono w rzeczywistym środowisku klinicznym, obejmującym pacjentów kierowanych na tomografię komputerową zgodnie ze standardową praktyką medyczną. Dzięki temu wyniki odzwierciedlają codzienne wyzwania, z którymi mierzą się lekarze medycyny ratunkowej, neurolodzy i radiolodzy.
        </p>
        <p>
          Oceny wyników tomografii komputerowej dokonywali radiolodzy pozostający w zaślepieniu względem rezultatów TES HT100, co zwiększa wiarygodność uzyskanych danych.
        </p>
      </section>

      <section>
        <h2>Wcześniejsze publikacje naukowe dotyczące Temnografii</h2>
        <p>Badanie realizowane w Szpitalu Pineta Grande nie było pierwszym projektem klinicznym dotyczącym technologii Temnografii.</p>

        <h3>2023 r. - Temnografia w diagnostyce udaru mózgu</h3>
        <p>
          W publikacji Vaia i wsp. zatytułowanej “Temnography HT in the Early Diagnosis of Brain Lesions Caused by Ischemic or Hemorrhagic Stroke” opisano zastosowanie Temnografii HT we wczesnym wykrywaniu zmian mózgowych związanych z udarem niedokrwiennym i krwotocznym. Autorzy wskazali na potencjał tej technologii jako szybkiego i nieinwazyjnego narzędzia wspomagającego ocenę neurologiczną pacjentów.
        </p>

        <h3>2024 r. - TES HT100 u pacjentów z urazami głowy</h3>
        <p>
          W pracy Montemerani i wsp. oceniano zastosowanie TES HT100 u pacjentów z łagodnym urazem mózgu. Autorzy uznali wyniki za obiecujące i wskazali na potrzebę przeprowadzenia większych badań klinicznych.
        </p>

        <h3>2026 r. - największe dotychczas badanie kliniczne</h3>
        <p>
          Badanie przeprowadzone w Szpitalu Pineta Grande, obejmujące 301 pacjentów, stanowi jedno z największych dotychczasowych opracowań klinicznych dotyczących technologii TES HT100 i ważny krok w kierunku dalszej walidacji tej metody.
        </p>
      </section>

      <section>
        <h2>Potwierdzona technologia dla nowoczesnej medycyny ratunkowej</h2>
        <p>
          Dostępne publikacje naukowe pokazują konsekwentny rozwój technologii Temnografii: od pierwszych doniesień dotyczących diagnostyki udaru mózgu, przez ocenę pacjentów z urazami głowy, aż po szerokie badanie kliniczne przeprowadzone w Szpitalu Pineta Grande oraz dalszą ekspansję programu badawczego do kolejnych ośrodków europejskich.
        </p>
        <p>
          Pierwsza analiza pośrednia obejmująca 301 pacjentów wykazała czułość 96,2% oraz ujemną wartość predykcyjną 95,2%. Wyniki zostały udostępnione w trybie wczesnym (early online) w <em>BMC Emergency Medicine</em> w artykule pozostającym obecnie w statusie Article in Press. Program TESCO obejmuje już 600 pacjentów zrekrutowanych we Włoszech, a kolejnych 250 pacjentów ma zostać włączonych w Polsce, co systematycznie poszerza bazę danych klinicznych dotyczącą TES HT100.
        </p>
        <p>
          TES HT100 to innowacyjne rozwiązanie wspierające wczesną ocenę pacjentów z urazami głowy i ostrymi objawami neurologicznymi, którego rozwój opiera się na systematycznie prowadzonych badaniach klinicznych realizowanych w rzeczywistych warunkach praktyki medycznej.
        </p>
      </section>

      <footer>
        <h3>Literatura i źródła:</h3>
        <ol>
          <li>
            Conte A.M., Alfieri F., Localzo A. i wsp. Prospective Blinded Interim Evaluation of the TES HT100 Portable Radiofrequency Device Supporting Emergency Department Triage in Patients with Mild Head Trauma or Acute Neurological Symptoms. <em>BMC Emergency Medicine</em>, 2026. DOI: 10.1186/s12873-026-01676-8
          </li>
          <li>
            Vaia S. i wsp. Temnography HT in the Early Diagnosis of Brain Lesions Caused by Ischemic or Hemorrhagic Stroke. <em>International Journal of Advanced Research</em>, 2023;11:191–195. DOI: 10.21474/IJAR01/17695
          </li>
          <li>
            Montemerani S. i wsp. Assessment of Temnography Reliability in Early Detection of Intracranial Lesions in Mild Traumatic Brain Injury Patients. <em>Open Access Emergency Medicine</em>, 2024;16:313–321. DOI: 10.2147/OAEM.S475328
          </li>
        </ol>
      </footer>
    </article>
                        </div>
                    </div>
                </div>
                <div className={"tesapp-footer-2 tesapp-c-component"} id="dystrybutor">
                    <h1 className={"tesapp-title-black"}>Dystrybutor</h1>
                    <div className={"tesapp-footer-body"}>
                        <div className={"tesapp-distributor-container"}>
                            <img src={"/logo.png"} className={"tesapp-cmp-icon"} width={160} height={50}/>
                            <div className={"tesapp-cmp-present"}>
                                <div className={"tesapp-distributor-info"}>
                                    <div><b>Medical Service Sp. z o. o.</b></div>
                                    <div>ul. Jordana 25</div>
                                    <div>40-952 Katowice</div>
                                </div>
                            </div>
                            <div className={"tesapp-cmp-more-info"}>
                                <div>NIP: 9542468164</div>
                                <div>Tel./Fax 257 84 40 | <b>+48 605405477</b></div>
                                <div>Mail: ms@medical-service.pl</div>
                            </div>
                        </div>
                        <div className={"footer-body-action"}>
                            <a href={"//medical-service.pl"} target={"_blank"} className={"tesapp-btn"}>Otwórz stronę
                                internetową</a>
                        </div>
                    </div>
                </div>
                <div className={"tesapp-footer"}>
                    <div className={"tesapp-footer-col-left"}>
                        <div className={"tesapp-distributor"}>
                            <div className={"tesapp-text-upper-white-mdk384"}>&copy; 2024 Wszelkie prawa zastrzeżone
                            </div>
                        </div>
                    </div>
                       <div className={"tesapp-footer-col-right"}>
                        Stworzono przez <b><a href={"//proevent-solutions.pl/"} style={{color: "white", textDecoration: "none"}}
                                              target={"_blank"}>PROEVENT SOLUTIONS Sp. z o. o.</a></b>
                    </div>
                </div>
            </div>

        </div>
      </>
  )
}